import { createApp } from 'vue';
import MovToWavConverter from '@/Components/MovToWavConverter.vue';
import '@styles/app.css';

createApp(MovToWavConverter).mount('#mov-to-wav-converter');
